import { computed, defineComponent, inject, onMounted } from 'vue';

import { PersonalityTestTracker } from "@/classes/tracker";
import { Routes } from "@/enums/routes";
import { IStore } from "@/interfaces/state.interface";

import ImageLoader from '@/classes/image-loader';

export default defineComponent({
	setup: () => {
		const store = inject('store') as IStore;
		const firstUnansweredQuestion = computed((): number => {
			return store.getters.firstUnansweredQuestion();
		});

		onMounted((): void => {
			// Preload the next unanswered question image, just in case the user decides to continue.
			if (firstUnansweredQuestion.value !== 0) {
				ImageLoader.preload(firstUnansweredQuestion.value);
			}

			// Always preload the first question image, just in case the user decides to (re)start the test.
			ImageLoader.preload(0);
		});

		const restartTest = (): void => {
			PersonalityTestTracker.fireTracking('test_restart', 'home');

			store.actions.resetStoredAnswers();
			initiateTest();
		};

		const startTest = (type: string, question = 0): void => {
			PersonalityTestTracker.fireTracking(`test_${type}`, question.toString());

			initiateTest(question);
		};

		const initiateTest = (question = 0): void => {
			store.mutations.setCurrentRoute(Routes.QUESTION, { question });
		};

		return { restartTest, startTest, initiateTest, firstUnansweredQuestion };
	}
});
